var _a, _b;
import { TSL_DIAGNOSTIC_KEYS } from '../tsl/core/parser';
import { FIELD_QUERY_DIAGNOSTIC_KEYS } from './compile';
import { TYPE_LABEL_KEY } from './registry';
/**
 * CZNA-217 — translation ids for the keys the TSL core and the compiler emit. Written
 * out in full so the translation-integrity gate sees every id as static.
 */
/**
 * The words the registry asks for: relation codes (the equality codes of other data
 * types too — the core reads them to recognise `je`) and the `Typ` label.
 */
export var REGISTRY_MESSAGE_IDS = (_a = {
        STR_CONTAINS: 'ui-czna-authorities.fieldQuery.relation.contains',
        STR_STARTS: 'ui-czna-authorities.fieldQuery.relation.startsWith',
        STR_EQ: 'ui-czna-authorities.fieldQuery.relation.equals',
        NUM_EQ: 'ui-czna-authorities.fieldQuery.relation.equals',
        DAT_EQ: 'ui-czna-authorities.fieldQuery.relation.equals',
        BOOL_EQ: 'ui-czna-authorities.fieldQuery.relation.equals',
        STR_MATCHES: 'ui-czna-authorities.fieldQuery.relation.matches',
        STR_FILLED: 'ui-czna-authorities.fieldQuery.relation.exists'
    },
    _a[TYPE_LABEL_KEY] = 'ui-czna-authorities.fieldQuery.typeLabel',
    _a);
var D = 'ui-czna-authorities.fieldQuery.diagnostic';
/** Diagnostic message ids by the key the parser or the compiler put on the diagnostic. */
export var DIAGNOSTIC_MESSAGE_IDS = (_b = {},
    _b[TSL_DIAGNOSTIC_KEYS.unterminatedQuote] = "".concat(D, ".unterminatedQuote"),
    _b[TSL_DIAGNOSTIC_KEYS.missingValue] = "".concat(D, ".missingValue"),
    _b[TSL_DIAGNOSTIC_KEYS.missingSecondValue] = "".concat(D, ".missingValue"),
    _b[TSL_DIAGNOSTIC_KEYS.unknownPseudoValue] = "".concat(D, ".unknownType"),
    _b[TSL_DIAGNOSTIC_KEYS.unknownCodebookValue] = "".concat(D, ".unknownType"),
    _b[TSL_DIAGNOSTIC_KEYS.invalidNumberValue] = "".concat(D, ".invalidValue"),
    _b[TSL_DIAGNOSTIC_KEYS.invalidDateValue] = "".concat(D, ".invalidValue"),
    _b[TSL_DIAGNOSTIC_KEYS.invalidBooleanValue] = "".concat(D, ".invalidValue"),
    _b[TSL_DIAGNOSTIC_KEYS.cannotNegate] = "".concat(D, ".cannotNegate"),
    _b[TSL_DIAGNOSTIC_KEYS.unexpectedSymbol] = "".concat(D, ".unexpectedSymbol"),
    _b[TSL_DIAGNOSTIC_KEYS.assumedFulltext] = "".concat(D, ".assumedWords"),
    _b[TSL_DIAGNOSTIC_KEYS.duplicateScope] = "".concat(D, ".invalidValue"),
    _b[TSL_DIAGNOSTIC_KEYS.unmatchedOpenParen] = "".concat(D, ".unmatchedOpenParen"),
    _b[TSL_DIAGNOSTIC_KEYS.unmatchedCloseParen] = "".concat(D, ".unmatchedCloseParen"),
    _b[TSL_DIAGNOSTIC_KEYS.tooManyCombinations] = "".concat(D, ".tooManyConditions"),
    _b[TSL_DIAGNOSTIC_KEYS.unrepresentableDisjunction] = "".concat(D, ".invalidValue"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.unknownField] = "".concat(D, ".unknownField"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.nestedWords] = "".concat(D, ".nestedWords"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.invalidRegex] = "".concat(D, ".invalidRegex"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.tooManyConditions] = "".concat(D, ".tooManyConditions"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.tooDeep] = "".concat(D, ".tooDeep"),
    _b[FIELD_QUERY_DIAGNOSTIC_KEYS.valueTooLong] = "".concat(D, ".valueTooLong"),
    _b);
/** Shown for a diagnostic key without its own message — never a raw key. */
export var GENERIC_DIAGNOSTIC_ID = "".concat(D, ".generic");
/**
 * Named values every diagnostic message may use, defaulted so a message never renders
 * an unfilled placeholder when the emitting site passed fewer params.
 */
export var DIAGNOSTIC_PARAM_DEFAULTS = {
    field: '',
    value: '',
    symbol: '',
    max: '',
};
